import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormGroupDirective, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ConfigurationService } from 'projects/zbs-app/src/app/components/configuration-select/configuration.service';
import { SearchLimitService, SearchType } from 'projects/zbs-app/src/app/search-limit.service';
import { ArticleSearch } from 'projects/zbs-app/src/app/services/Ebootis.Queries/ArticleSearch';
import { OrdersOfLogonUser } from 'projects/zbs-app/src/app/services/Ebootis.Queries/OrdersOfLogonUser';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { OrderService } from '../../order.service';
import { OrderTableData } from '../order-table/order-table.component';

@Component({
	selector: 'app-order-search',
	templateUrl: './order-search.component.html',
	styleUrls: ['./order-search.component.scss']
})
export class OrderSearchComponent implements OnInit, OnDestroy {

	@Output() public orderSelect: EventEmitter<string> = new EventEmitter();

	@ViewChild('formDirective', { static: true }) public formDirective: FormGroupDirective;

	private m_subscriptionsSubject = new Subject();
	public m_isLoading: boolean = false;
	public m_displayError: HttpErrorResponse;
	public m_messageHandlerClass: string = 'info';
	public m_orderData: OrderTableData;
	public m_selectedArticle: ArticleSearch.Article;
	public m_orderSearchForm: UntypedFormGroup;
	public readonly TX_DEF: string = 'txDef';
	public readonly NAME: string = 'name';
	public readonly STREET: string = 'street';
	public readonly ZIP: string = 'zip';
	public readonly CITY: string = 'city';
	public readonly COUNTRY: string = 'country';
	public readonly TRACKING_NO: string = 'trackingNo';
	public readonly HAS_TRACKING_NO: string = 'hasTrackingNo';
	public readonly ARTICLE: string = 'article';
	public readonly STATE: string = 'state';
	public readonly FROM_DATE: string = 'fromDate';
	public readonly TO_DATE: string = 'toDate';
	public readonly ID: string = 'id';
	public readonly LIMIT: string = 'limit';
	public readonly TO_AUTHORIZE = 'onlyToAuthorize';
	public m_configOid: string = '';
	public m_hasAuthorizationRole: boolean = false;
	// public m_orderStates$: Observable<OrderStates.Result[]> = this.orderService.getOrderStates();

	constructor(
		private orderService: OrderService,
		private fb: UntypedFormBuilder,
		private configurationService: ConfigurationService,
		private limitService: SearchLimitService
	) {
		this.m_configOid = this.configurationService.SelectedConfigOid;
		this.configurationService.getConfiguration().pipe(takeUntil(this.m_subscriptionsSubject)).subscribe({
			next: (config) => {
				this.m_hasAuthorizationRole = config?.hasAuthorizationRole;
			}
		});
		this.limitService.setLimitList(SearchType.ORDER, [100, 250, 500, 1000, 1500, 3000])
		this.m_orderSearchForm = this.fb.group({
			[this.TX_DEF]: [],
			[this.ARTICLE]: [],
			[this.STATE]: [],
			[this.FROM_DATE]: [],
			[this.TO_DATE]: [],
			[this.ID]: [],
			[this.NAME]: [],
			[this.STREET]: [],
			[this.ZIP]: [],
			[this.CITY]: [],
			[this.COUNTRY]: [],
			[this.TRACKING_NO]: [],
			[this.HAS_TRACKING_NO]: [],
			[this.TO_AUTHORIZE]: [],
			limit: [limitService.getSetLimit(SearchType.ORDER), Validators.required],
		});
	}

	m_sortAttribute: string = 'creationDate';

	/**
	 * OrderFormGroup wird auf Defaultwerte gesetzt.
	 */
	public ngOnInit(): void {
	}

	getLimitList() {
		return this.limitService.getLimitList(SearchType.ORDER);
	}

	/**
	 * Die Subscriptions werden geschlossen.
	 */
	public ngOnDestroy(): void {
		this.m_subscriptionsSubject.next(null);
		this.m_subscriptionsSubject.complete();
	}

	/**
	 * Die OrderSearch wird ausgelöst. Die eingegebenen Suchparameter werden falls ausgefüllt gesetzt.
	 */
	public orderSearchForm_Submit(): void {
		this.m_isLoading = true;
		const params = new OrdersOfLogonUser.Params();
		params.zbsConfig = this.m_configOid;

		if (this.m_selectedArticle && this.m_selectedArticle.oid) {
			params.articleProxy = this.m_selectedArticle.proxyOid;
		}
		if (this.getControl('state').value) {
			params.deliveryState = this.getControl('state').value;
		}
		if (this.getControl('fromDate').value) {
			params.txDateFrom = this.getControl('fromDate').value;
		}
		if (this.getControl('toDate').value) {
			params.txDateUntil = this.getControl('toDate').value;
		}

		params.name = this.getControl(this.NAME).value;
		params.street = this.getControl(this.STREET).value;
		params.zip = this.getControl(this.ZIP).value;
		params.city = this.getControl(this.CITY).value;
		params.country = this.getControl(this.COUNTRY).value;
		params.trackingno = this.getControl(this.TRACKING_NO).value;
		//achtung: false=null sonst würden wir nur Bestellungen OHNE Senundsnummern ermitteln
		params.hasTrackingnos = this.getControl(this.HAS_TRACKING_NO).value ? true : null;
		// auch hier achtung: false=null
		params.onlyToAuthorize = this.getControl(this.TO_AUTHORIZE).value ? true : null;

		if (this.getControl(this.TX_DEF).value) {
			params.txDef = this.getControl(this.TX_DEF).value;
		}
		if (this.getControl('id').value) {
			params.id = this.getControl('id').value;
		}
		params.limit = this.getControl('limit').value;
		params.sortAttribute = this.m_sortAttribute;
		this.orderService.searchOrders(params).pipe(
			takeUntil(this.m_subscriptionsSubject)
		).subscribe({
			next: (data) => {
				if (data) {
					this.m_orderData = {
						orders: data.sort((a, b) => { return a.txDate < b.txDate ? 1 : -1; }),
						hasTrackingnos: this.getControl(this.HAS_TRACKING_NO).value,
					}
				} else {
					// this.m_orderData = [];
					this.m_orderData = {
						orders: [],
						hasTrackingnos: this.getControl(this.HAS_TRACKING_NO).value,
					}
				}
				this.m_isLoading = false;
			},
			error: (error) => {
				this.m_isLoading = false;
				this.m_displayError = error;
				this.m_messageHandlerClass = 'danger';
			}
		});
	}

	/**
	 * Die OrderFormGroup wird zurückgesetzt.
	 */
	public resetOrderSearchForm_Click(): void {
		this.m_orderData = undefined;
		this.formDirective.resetForm();
		this.m_orderSearchForm.reset();
		this.getControl('limit').setValue(100);
		this.m_selectedArticle = undefined;
	}

	/**
	 * Setzt ein FormControl zurück.
	 * @param p_controlName FormControlName
	 */
	public clearInput_Click(p_controlName): void {
		this.getControl(p_controlName).setValue(null);
	}

	/**
	 * Eine ausgewählte Order wird an das übergeordenete Component übergeben.
	 * @param p_order Ausgewählte Order
	 */
	public orderSelected(p_order: string): void {
		this.orderSelect.emit(p_order);
	}
	public sortAttributeChanged(p_sortAttribute: string) {
		this.m_sortAttribute = p_sortAttribute;
		this.orderSearchForm_Submit();
	}
	/**
	 * Gibt ein FormControl basierend auf dessen Name zurück.
	 * @param p_name FormControlName
	 */
	public getControl(p_name: string): AbstractControl {
		return this.m_orderSearchForm.get(p_name);
	}

	/**
	 * Die Nachrichten des MessageHandlers werden zurückgesetzt.
	 */
	public clearDisplayMessages(): void {
		this.m_displayError = null;
	}

}
